const auth = {
  namespaced: true,
  state: () => ({
    userInfo: {
    },
  }),
  mutations: {
    setUserInfo(state, val) {
      state.userInfo = val;
      // state.userInfo.userid = '1425772969427312641';
    },
  },
  actions: {
  },
  getters: {
    userId(state) {
      return state.userInfo?.userid || localStorage.getItem('setUserid');
      // return '1425772969427312641';
    },
    isStudent(state) {
      // eslint-disable-next-line eqeqeq
      return state.userInfo?.is_stu_tea == 1;
      // return false;
    },
  },
};

export default auth;
